<template>
  <div
    class="page-content"
  >
    <!-- 顶部 -->
    <div class="product-top">
      <div class="product-img skeleton-item"></div>
      <div class="product-top-right">
        <h4 class="product-name skeleton-item"></h4>
        <div class="product-intro skeleton-item"></div>
        <div>
          <div class="info-item skeleton-item"></div>
        </div>
      </div>
      <div class="exchange-text skeleton-item"></div>
    </div>
    <!-- 选项卡 -->
    <div class="tab-box">
      <span class="tab-item skeleton-item"></span>
      <span class="tab-item skeleton-item"></span>
      <div class="version-box">
        <div class="version skeleton-item"></div>
        <div class="version skeleton-item"></div>
        <div class="version skeleton-item"></div>
      </div>
      <div class="tab-content skeleton-item"></div>
    </div>
  </div>
</template>
<script>
export default {
  
};
</script>
<style lang="less" scoped>
@keyframes skeleton-stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 20rem 0;
  }
}
.skeleton-item {
  background-color: #f2f2f2;
}
.skeleton-item.ske-ani {
  animation: skeleton-stripes 1s linear infinite;
  background: #f1f3f4 linear-gradient(90deg, rgba(255, 255, 255, 0.39) 25%, transparent 25%);
  background-size: 20rem 20rem;
}
.product-top {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 30px;
  display: flex;
  // align-items: center;
  .product-img {
    // float: left;
    width: 304px;
    height: 214px;
    flex-shrink: 0;
  }
  .product-top-right {
    // float: left;
    padding-left: 20px;
  }
  .product-name {
    height: 30px;
    width: 200px;
    margin-bottom: 30px;
  }
  .product-intro {
    height: 20px;
    width: 600px;
    margin-bottom: 30px;
  }
  .info-item {
    height: 25px;
    width: 300px;
    margin-bottom: 15px;
    &:last-child {
      width: 100px;
      height: 30px;
      margin-bottom: 0;
    }
  }
  .exchange-text {
    position: absolute;
    right: 30px;
    bottom: 30px;
    width: 200px;
    height: 20px;
  }
  .sku-item {
    font-size: 12px;
    color: #666;
    border: 1px solid #e0e0e0;
    padding: 3px 10px;
    // border-radius: 5px;
    margin-bottom: 20px;
    position: relative;
    margin-right: 10px;
    cursor: pointer;
    &.select {
      border: 1px solid #409eff;
      background: #eef5fb;
      &::after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-bottom: 8px solid #409eff;
        border-left: 8px solid transparent;
        right: -1px; // 解决像素偏差问题
        bottom: -1px;// 解决像素偏差问题
      }
    }
  }
}
.tab-box {
  background-color: #fff;
  padding: 30px;
  // height: 300px;
  .tab-item {
    display: inline-block;
    width: 80px;
    height: 25px;
    margin-right: 10px;
  }
  .tab-content {
    margin-top: 10px;
    height: 300px;
  }
  .version-box {
    display: flex;
    justify-content: space-around;
    padding: 20px;
    .version {
      height: 206px;
      width: 31%;
    }
  }
}
</style>